import template from "./profile.html";
import controller from "./profile.controller";

const profileComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller,
};

export default profileComponent;
